import { render, staticRenderFns } from "./EnterOpt.vue?vue&type=template&id=2796ae36&scoped=true"
import script from "./EnterOpt.vue?vue&type=script&lang=js"
export * from "./EnterOpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796ae36",
  null
  
)

export default component.exports